import { playerDisplayName } from "./PlayerDisplayNameLink";
/** A summary-only player (someone off the roster but in a match) carries a
 * precomputed `name`; a full Player/TeamMembershipPlayer derives it from `user`. */
export const isPlayerSummary = (player) => !("user" in player);
/** Display name for either a full player or a summary-only player. */
export const playerSummaryName = (player) => isPlayerSummary(player) ? player.name ?? "" : playerDisplayName(player);
export const findPlayerById = (players) => {
    return (id) => {
        return players.find((player) => player.id === id);
    };
};
